// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#6CB59D',
        secondary: '#555555',
        accent: '#FF8C22',
        background: '#F5F5F5',
        days: '#CEE5DD',
        grey5: '#555555',
        booked: '#6CB59D',
        history: '#C9C9C9',
      },
    },
  },
})
